export const excludedStripeCouponCodeIds = ["RECOMMIT10"];
